import { Checkbox } from "@/design-system/components/Checkbox/Checkbox";

interface DocsTermsAgreementProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

// Consent control shown before a visitor is signed into the docs. The full
// text lives at /docs-terms (DocsTermsPage), opened in a new tab so the
// visitor doesn't lose their place in the login flow.
function DocsTermsAgreement({ checked, onChange }: DocsTermsAgreementProps) {
  return (
    <label className="text-textSubtle flex cursor-pointer items-start gap-2 text-sm">
      <Checkbox
        checked={checked}
        onCheckedChange={(c) => onChange(c === true)}
      />
      <span>
        I have read and agree to the{" "}
        <a
          href="/docs-terms"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer font-medium text-blue-600 underline"
          onClick={(e) => e.stopPropagation()}
        >
          Documentation Terms of Use
        </a>
        .
      </span>
    </label>
  );
}

export default DocsTermsAgreement;
